// ライフソムリエール独自: MINATO家事＋のお子様ごとの利用時間の入力
// (app/views/site_customs/life_sommelier/form/_minato_child_allocation.html.slim)
//
// - 希望日(未入力なら今日)を含む年齢区分の枠で、各お子様の年齢・残り時間・期限・選択できる時間を表示する
//   (誕生日以降の希望日なら、リセット後の36時間になる)
// - 作業時間の選択肢を自治体補助対象ごとに絞る(MINATO家事＋: 2・3・4時間、文京区補助事業: 1〜6時間の1時間単位)
// - お子様ごとの利用時間の合計が作業時間と一致しない、または残り時間を超える場合はアラートを出し、送信をブロックする
// サーバ側(Customs::LifeSommelier::MinatoTime、Requests::Validatable)にも同じ判定があるため、変更時は両方を揃えること。
import moment from 'moment'

$(() => {
  $('.js-minato-child-allocation').each((_, root) => {
    const $root = $(root)
    const $form = $root.closest('form')
    const config = $root.data('minato')
    const unitMinutes = config.unit_minutes
    const children = config.children

    const $value = $root.find('.js-minato-allocation-value')
    const $check = $root.find('.js-minato-allocation-check')
    const $alert = $root.find('.js-minato-allocation-alert')
    const $alertMessage = $root.find('.js-minato-allocation-alert-message')
    const $workMinutes = $form.find('select[name$="[int_1]"]')
    const $desiredDt = $form.find('input[name$="[desired_dt]"]').first()
    const subsidyName = $value.attr('name').replace(/\[(?!.*\[).*/, '[str_8]')

    // 作業時間の元の選択肢(絞り込み対象外の補助の時に戻す)
    const originalWorkOptions = $workMinutes.find('option').map((_, option) => ({
      value: $(option).val(),
      label: $(option).text(),
    })).get()
    // 画面表示時の作業時間(登録済みの依頼の値)。補助対象の単位に合わなくても選択肢に残し、意図せず変わらないようにする
    const initialWorkMinutes = $workMinutes.val()

    const formatHours = (minutes) => {
      const hours = minutes / 60
      return Number.isInteger(hours) ? `${hours}` : `${Math.round(hours * 10) / 10}`
    }

    const formatDate = (date) => moment(date).format('YYYY/MM/DD')

    const selectedSubsidy = () => $form.find(`input[name="${subsidyName}"]:checked`).val()

    const isMinato = () => selectedSubsidy() === config.subsidy_choice_id

    const baseDate = () => {
      const value = $desiredDt.val()
      return value ? moment(value, 'YYYY-MM-DD') : moment(config.today, 'YYYY-MM-DD')
    }

    const age = (birthday, on) => {
      if (!birthday) {
        return null
      }
      return on.diff(moment(birthday, 'YYYY-MM-DD'), 'years')
    }

    const termOn = (child, on) => child.terms.find((term) => {
      return !on.isBefore(moment(term.from, 'YYYY-MM-DD')) && !on.isAfter(moment(term.to, 'YYYY-MM-DD'))
    })

    // 自治体補助対象ごとに作業時間の選択肢を絞る(Customs::LifeSommelier::MinatoTime.work_minutes_options_by_subsidy)
    const updateWorkMinutesOptions = () => {
      const current = $workMinutes.val()
      const allowedMinutes = config.work_minutes_options_by_subsidy[selectedSubsidy()]
      const options = allowedMinutes
        ? originalWorkOptions.filter((option) => allowedMinutes.includes(Number(option.value)) || option.value === initialWorkMinutes)
        : originalWorkOptions
      $workMinutes.empty()
      options.forEach((option) => {
        $workMinutes.append($('<option>').val(option.value).text(option.label))
      })
      if (options.some((option) => option.value === current)) {
        $workMinutes.val(current)
      } else if (options.length) {
        $workMinutes.val(options[0].value)
      }
    }

    const selectedMinutes = ($row) => Number($row.find('.js-minato-child-minutes').val()) || 0

    const renderRows = () => {
      const on = baseDate()
      const workMinutes = Number($workMinutes.val()) || 0

      $root.find('.js-minato-child-row').each((_, row) => {
        const $row = $(row)
        const child = children.find((c) => c.id === Number($row.data('child-id')))
        const term = termOn(child, on)
        const $select = $row.find('.js-minato-child-minutes')
        const $note = $row.find('.js-minato-child-note')
        const current = $select.data('rendered') ? selectedMinutes($row) : Number($row.data('initial-minutes')) || 0
        const childAge = age(child.birthday, on)

        $row.find('.js-minato-child-age').text(childAge === null ? '-' : `${childAge}歳`)

        let note = ''
        let max = 0
        if (!term) {
          $row.find('.js-minato-child-remaining').text('-')
          $row.find('.js-minato-child-term').text('')
          const first = child.terms[0]
          if (!first) {
            note = '生年月日が登録されていません'
          } else if (on.isBefore(moment(first.from, 'YYYY-MM-DD'))) {
            note = `満3歳（${formatDate(first.from)}）から利用できます`
          } else {
            note = '対象期間外のため選択できません'
          }
        } else {
          $row.find('.js-minato-child-remaining').text(`${formatHours(term.remaining)}時間`)
          $row.find('.js-minato-child-term').text(`${formatDate(term.to)}まで`)
          max = Math.min(term.remaining, workMinutes)
          if (term.remaining <= 0) {
            note = '残り時間がないため選択できません'
          }
        }

        // 選択肢: 0〜min(残り時間, 作業時間)。希望日の変更などで上限を超えた入力済みの値は残してアラートで知らせる
        const options = []
        for (let minutes = 0; minutes <= max; minutes += unitMinutes) {
          options.push(minutes)
        }
        if (current > 0 && !options.includes(current)) {
          options.push(current)
        }
        $select.empty()
        options.forEach((minutes) => {
          $select.append($('<option>').val(minutes).text(minutes === 0 ? '0' : formatHours(minutes)))
        })
        $select.val(current)
        $select.data('rendered', true)
        $select.prop('disabled', max <= 0 && current <= 0)
        $row.toggleClass('text-muted', max <= 0)
        $note.text(note)
      })

      prefillSingleChild(workMinutes)
    }

    // 選べるお子様が1人だけで未入力なら、作業時間をそのまま入れておく
    const prefillSingleChild = (workMinutes) => {
      const $rows = $root.find('.js-minato-child-row')
      const $selectable = $rows.filter((_, row) => !$(row).find('.js-minato-child-minutes').prop('disabled'))
      const total = $rows.get().reduce((sum, row) => sum + selectedMinutes($(row)), 0)
      if ($selectable.length !== 1 || total > 0) {
        return
      }
      const $select = $selectable.find('.js-minato-child-minutes')
      if ($select.find(`option[value="${workMinutes}"]`).length) {
        $select.val(workMinutes)
      }
    }

    // initial: 画面表示直後。未入力の状態でアラートを出さないため、送信のブロックだけ行う
    const validate = (initial = false) => {
      if (!isMinato()) {
        $value.val('')
        $alert.addClass('d-none')
        $check.val('1')
        if (!initial) {
          $check.trigger('change')
        }
        return
      }

      const on = baseDate()
      const workMinutes = Number($workMinutes.val()) || 0
      const allocations = {}
      const messages = []
      let total = 0

      $root.find('.js-minato-child-row').each((_, row) => {
        const $row = $(row)
        const minutes = selectedMinutes($row)
        if (minutes <= 0) {
          return
        }
        const child = children.find((c) => c.id === Number($row.data('child-id')))
        const term = termOn(child, on)
        allocations[child.id] = minutes
        total += minutes
        if (!term) {
          messages.push(`${child.name}さんはご希望日時点で対象期間外です。`)
        } else if (minutes > term.remaining) {
          messages.push(`${child.name}さんの利用時間（${formatHours(minutes)}時間）が残り時間（${formatHours(term.remaining)}時間）を超えています。`)
        }
      })

      if (total !== workMinutes) {
        messages.unshift(`お子様の合計利用時間（${formatHours(total)}時間）が、選択した作業時間（${formatHours(workMinutes)}時間）と一致していません。<br>各お子様の利用時間を変更するか、作業時間を変更してください。`)
      }

      $value.val(Object.keys(allocations).length ? JSON.stringify(allocations) : '')
      $check.val(messages.length ? '' : '1')
      if (messages.length && (!initial || total > 0)) {
        $alertMessage.html(messages.join('<br>'))
        $alert.removeClass('d-none')
      } else {
        $alert.addClass('d-none')
      }
      if (!initial) {
        $check.trigger('change')
      }
    }

    const refresh = (initial = false) => {
      updateWorkMinutesOptions()
      renderRows()
      validate(initial)
    }

    $form.on('change', `input[name="${subsidyName}"]`, () => refresh())
    $workMinutes.on('change', () => {
      renderRows()
      validate()
    })
    $desiredDt.on('change', () => {
      renderRows()
      validate()
    })
    $root.on('change', '.js-minato-child-minutes', () => validate())
    // 未入力のまま確認ボタンを押した場合もアラートを表示する
    $form.find('.submit').on('click', () => validate())

    refresh(true)
  })
})
